import { IRoute, Routes } from './route';

// menu
export const RouteMenus: IRoute[] = [
  Routes.HOME,
  Routes.CUSTOMER,
  Routes.CATEGORY,
  Routes.POST,
  Routes.FILE,
  Routes.SETTING,
];
